export default __webpack_public_path__ + "static/media/introduction-poster.1c54356e.png";